module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp23_4.0a4bcd18.png";